import React from 'react';
import Plot from 'react-plotly.js';
import axios from 'axios';

/**
 * Create two arrays num length with random values from 0 to mul
 *
 * @param {*} num
 * @param {*} mul
 * @returns
 */



const API_URL = process.env.REACT_APP_API_URL || "https://api.glyphstats.com/api/";

class PlotGraph extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
        graph: []
      }
    }

  componentDidMount(){
    axios.get(API_URL + 'cluster-data/')
        .then(response => {
          this.setState({ graph: response.data })
      });
  }

  render() {

    const traces = this.state.graph.map((data, i) => {
    return {
        x: data['x_axes'],
        y: data['y_axes'],
        z: data['z_axes'],
        type: 'scatter3d',
        text: data['image'],
        mode: 'markers',
        hovertemplate:
            "%{text}"
      }
    });

    return (
      <Plot
        data={traces}
        layout={{
          hovermode:'closest',
          autosize: true,
          scene: {
              aspectratio: {
                  x: 1,
                  y: 1,
                  z: 1
              },
              camera: {
                  center: {
                      x: 0,
                      y: 0,
                      z: 0
                  },
                  eye: {
                      x: 1.25,
                      y: 1.25,
                      z: 1.25
                  },
                  up: {
                      x: 0,
                      y: 0,
                      z: 1
                  }
              }, 
              xaxis: {
                  type: 'linear',
                  zeroline: false,
                  showlegend: true,
              },
              yaxis: {
                  type: 'linear',
                  zeroline: false,
                  showlegend: false
              },
              zaxis: {
                  type: 'linear',
                  zeroline: false,
                  showlegend: false
              }
            },
          width: 1000,
          height: 1000,
          title: `3d point clustering`
        }}
      />
    );
  }
}

export default PlotGraph;


// WEBPACK FOOTER //
// ./src/PlotGraph.js